<template>
  <div class="wrapper">
    <div class="section page-header" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h1 class="title-white">{{ $t("concert.header_title") }}</h1>
          </div>
        </div>
        <div v-if="isMobileDevice" class="md-layout margin-top-64">
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">{{ $t("common.time") }}<br />2020</h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.role") }}<br />Creative 3D UX Design, PM
            </h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.platform") }}<br />Mobile, Desktop, Console
            </h4>
          </div>
        </div>
        <div v-else class="md-layout margin-top-64">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">{{ $t("common.time") }}<br />2020</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.role") }}<br />Creative 3D UX Design, PM
              </h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.platform") }}<br />Mobile, Desktop, Console
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-black">
      <div class="large-section large-section-black">
        <div class="section">
          <div class="container">
            <div class="md-layout" :style="introStyle">
              <div
                class="md-layout-item md-size-100 md-xsmall-size-100 text-center"
              >
                <h2 class="title-white intro_text_margin">
                  {{ $t("concert.intro") }}
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("concert.project.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100">
                <h4 class="content-white text-left">
                  {{ $t("concert.project.description1") }}
                </h4>
                <h4 class="content-white text-left">
                  {{ $t("concert.project.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <img :src="intro_phones[0].image" />
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <img :src="intro_phones[1].image" />
              </div>
              <div
                class="md-layout-item md-size-50 md-small-size-100 margin-top-32"
              >
                <img :src="intro_phones[2].image" />
              </div>
              <div
                class="md-layout-item md-size-50 md-small-size-100 margin-top-32"
              >
                <img :src="intro_phones[3].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section text-center">
          <div class="container">
            <div class="team">
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-33 md-small-size-100">
                  <md-card class="md-card-plain transparent">
                    <h1 class="card-title-white decoration">
                      {{ $t("concert.card1.number") }}
                      <h3 class="card-description-white">
                        {{ $t("concert.card1.description1") }}
                      </h3>
                    </h1>
                    <md-card-content>
                      <p class="card-description">
                        {{ $t("concert.card1.description2") }}
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="md-layout-item md-medium-size-33 md-small-size-100">
                  <md-card class="md-card-plain transparent">
                    <h1 class="card-title-white decoration">
                      {{ $t("concert.card2.number") }}
                      <h3 class="card-description-white">
                        {{ $t("concert.card2.description1") }}
                      </h3>
                    </h1>
                    <md-card-content>
                      <p class="card-description">
                        {{ $t("concert.card2.description2") }}
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
                <div class="md-layout-item md-medium-size-33 md-small-size-100">
                  <md-card class="md-card-plain transparent">
                    <h1 class="card-title-white decoration">
                      {{ $t("concert.card3.number") }}
                      <h3 class="card-description-white">
                        {{ $t("concert.card3.description1") }}
                      </h3>
                    </h1>
                    <md-card-content>
                      <p class="card-description">
                        {{ $t("concert.card3.description2") }}
                      </p>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section press-portrait-phones">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("concert.press.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100 mx-auto">
                <h3
                  class="title-white text-italic text-left press-cursor"
                  @click="openWebsite('verge')"
                >
                  {{ $t("concert.press.press_title1") }}
                </h3>
                <h4 class="title description text-left press-name-margin-top">
                  {{ $t("concert.press.press_name1") }}
                </h4>
                <h3
                  class="title-white text-italic text-left press-title-padding-top press-cursor"
                  @click="openWebsite('qq')"
                >
                  {{ $t("concert.press.press_title2") }}
                </h3>
                <h4 class="title description text-left press-name-margin-top">
                  {{ $t("concert.press.press_name2") }}
                </h4>
                <h3
                  class="title-white text-italic text-left press-title-padding-top press-cursor"
                  @click="openWebsite('appfollow')"
                >
                  {{ $t("concert.press.press_title3") }}
                </h3>
                <h4 class="title description text-left press-name-margin-top">
                  {{ $t("concert.press.press_name3") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-50 md-small-size-50">
                <img :src="portrait_phones[0].image" />
              </div>
              <div class="md-layout-item md-size-50 md-small-size-50">
                <img :src="portrait_phones[1].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("concert.ideation.title") }}
                </h2>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div
                class="md-layout-item md-size-50 md-small-size-100 md-item-right-padding md-item-bottom-padding"
              >
                <img :src="ideations[0].image" />
              </div>
              <div
                class="md-layout-item md-size-50 md-small-size-100 md-item-left-padding md-item-top-padding"
              >
                <img :src="ideations[1].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("concert.mechanics.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100 mx-auto">
                <h4 class="content-white text-left">
                  {{ $t("concert.mechanics.description1") }}<br />
                  {{ $t("concert.mechanics.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout-item md-grid section-internal-padding">
              <div>
                <img :src="mechanics[0].image" />
              </div>
              <div>
                <img :src="mechanics[1].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-40 md-small-size-100">
                <h2 class="title-white text-left">
                  {{ $t("concert.experience.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-60 md-small-size-100 mx-auto">
                <h4 class="content-white text-left">
                  {{ $t("concert.experience.description1") }}<br />
                  {{ $t("concert.experience.description2") }}<br />
                  {{ $t("concert.experience.description3") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div
                class="md-layout-item small-padding md-size-33 md-small-size-50"
              >
                <img :src="experience_enhancements[0].image" />
              </div>
              <div
                class="md-layout-item small-padding md-size-33 md-small-size-50"
              >
                <img :src="experience_enhancements[1].image" />
              </div>
              <div
                class="md-layout-item small-padding md-size-33 md-small-size-50"
              >
                <img :src="experience_enhancements[2].image" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="video-wrapper">
              <img
                class="video-image-ratio"
                src="@/assets/img/common/video_placeholder.png"
              />
              <iframe
                height="498"
                width="510"
                src="https://www.youtube.com/embed/-qHivchnvDk?si=742QmV0DuLvsr9h1"
                frameborder="0"
                allowfullscreen="true"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main-->
  </div>
  <!-- wrapper-->
</template>

<script>
export default {
  bodyClass: "concert-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/concert/background.png")
    },
    intro_background: {
      type: String,
      default: require("@/assets/img/concert/concert_intro_background.png")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      intro_phones: [
        { image: require("@/assets/img/concert/intro_phone1.png") },
        { image: require("@/assets/img/concert/intro_phone2.png") },
        { image: require("@/assets/img/concert/intro_phone3.png") },
        { image: require("@/assets/img/concert/intro_phone4.png") }
      ],
      portrait_phones: [
        { image: require("@/assets/img/concert/portrait_phone1.png") },
        { image: require("@/assets/img/concert/portrait_phone2.png") }
      ],
      experience_enhancements: [
        { image: require("@/assets/img/concert/experience_enhancement_1.png") },
        { image: require("@/assets/img/concert/experience_enhancement_2.png") },
        { image: require("@/assets/img/concert/experience_enhancement_3.png") }
      ],
      ideations: [
        { image: require("@/assets/img/concert/ideation_1.png") },
        { image: require("@/assets/img/concert/ideation_2.png") }
      ],
      mechanics: [
        { image: require("@/assets/img/concert/mechanic_1.png") },
        { image: require("@/assets/img/concert/mechanic_2.png") }
      ]
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 43.82%, rgba(0, 4, 52, 0.59) 69.86%, rgba(0, 1, 18, 0.855896) 85.66%, #000000 100%),  url(${this.header})`
      };
    },
    introStyle() {
      return {
        backgroundImage: `url(${this.intro_background})`,
        backgroundSize: `cover`
      };
    }
  },
  methods: {
    openWebsite(website) {
      if (website === "verge") {
        window.open(
          "https://www.theverge.com/2020/11/16/21570454/lil-nas-x-roblox-concert-33-million-views",
          "_blank"
        );
      } else if (website === "qq") {
        window.open(
          "https://new.qq.com/omn/20201123/20201123A0DHTG00.html",
          "_blank"
        );
      } else if (website === "appfollow") {
        window.open(
          "https://appfollow.io/featured/today#country=us&from=2020-11-14&to=2020-11-14",
          "_blank"
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.intro_text_margin {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem;
  margin-left: 2rem;
  margin-right: 2rem;
}
.press-cursor {
  cursor: pointer;
}
.press-title-padding-top {
  padding-top: 2.85rem;
}
.press-name-margin-top {
  margin-top: 0.25rem;
}
.press-portrait-phones {
  padding-bottom: 0;
}
.padding-to-align-bottom {
  padding-bottom: 22px;
}
a {
  color: none;
  text-decoration: none;
}
.transparent {
  background-color: transparent !important;
}
</style>
